// steps.js or steps.tsx
const StepsPC = [
	{
		target: 'BTCP-logo',
		content: (
			<>
				A space for BTCP leads and supporters to connect, share
				resources, and collaborate.
			</>
		),
	},
	{
		target: 'create-project',
		content: (
			<>
				Click here to open the form and submit your project details to
				create a new project on this portal.
			</>
		),
	},
	{
		target: 'search-input',
		content: <>Search projects by name, city, status, or pathway.</>,
	},
	{
		target: 'filter-menu',
		content: (
			<>
				Filter projects by city, status, pathway, or funding source.
				Select the criteria you wish to apply, and use Clear Filter to
				reset all selections.
			</>
		),
	},
	{
		target: 'profile',
		content: (
			<>
				Click your profile picture to log out. Once you create a
				project, it will appear here for your view and access.
			</>
		),
	},
	{
		target: 'cardDetails',
		content: (
			<>
				View key project details such as name, status, logo (top left),
				and a brief description in the card. Click on the project card
				for more information.
			</>
		),
	},
]

const StepsPhone = [
	{
		target: 'BTCP-logo',
		content: (
			<>
				A space for BTCP leads and supporters to connect, share
				resources, and collaborate.
			</>
		),
	},
	{
		target: 'create-project',
		content: (
			<>
				Click here to open the form and submit your project details to
				create a new project on this portal.
			</>
		),
	},
	{
		target: 'search-input',
		content: <>Search projects by name, city, status, or pathway.</>,
	},
	{
		target: 'filter-menu-phone',
		content: (
			<>
				Filter projects by city, status, pathway, or funding source.
				Select the criteria you wish to apply, and use Clear Filter to
				reset all selections.
			</>
		),
	},
	{
		target: 'phoneProfile',
		content: (
			<>
				Click the hamburger menu to access the logout option. After you
				create a project, it will appear here for your reference and
				access.
			</>
		),
	},
	{
		target: 'cardDetails',
		content: (
			<>
				View key project details such as name, status, logo (top left),
				and a brief description in the card. Click on the project card
				for more information.
			</>
		),
	},
]

const isSmallScreen =
	typeof window !== 'undefined' &&
	window.matchMedia('(max-width: 880px)').matches

export const Steps = isSmallScreen ? StepsPhone : StepsPC
